import { useEffect, useState } from 'react';
import '../styles/Transitions.css';

function Transitioner({ children, animation = 'slide', duration = 500 }) {
  const [className, setClassName] = useState(`${animation}-enter`);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Enter animation
    setClassName(`${animation}-enter`);
    
    const startAnimation = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setClassName(`${animation}-enter ${animation}-enter-active`);
        });
      });
    };

    startAnimation();

    return () => {
      // Clean up for exit animation if needed later
    };
  }, [animation]);

  if (!visible) return null;

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        overflowX: 'hidden',
        width: '100%',
        willChange: 'transform',
      }}
    >
      {children}
    </div>
  );
}

export default Transitioner;
